import { Routes } from '@angular/router';
import { LOGIN_CONFIGS } from './base/login-config';

export const loginRoutes: Routes = [
  {
    // 🔴 'login' 보다 **먼저** 선언한다.
    //
    // Angular 의 기본 pathMatch 는 'prefix' 라 `path: 'login'` 이 `/login/callback` 의 앞부분과도
    // 일치한다. 자식 라우트가 없어 결국 매치가 거절되고 이 라우트로 넘어오긴 하지만, 그 동작은
    // 라우터의 백트래킹에 기대는 것이라 읽는 사람에게 드러나지 않는다. 순서로 의도를 명시한다.
    //
    // 이 경로는 authGuard 밖에 있어야 한다(로그인 전에 도달하는 착지점이므로) — app.routes.ts 가
    // loginRoutes 를 가드 없는 최상위에 펼치고 있어 충족된다.
    path: 'login/callback',
    loadComponent: () =>
      import('./components/login-callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: 'login',
    data: { config: LOGIN_CONFIGS['admin'] },
    loadComponent: () =>
      import('./components/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'loginPartner',
    data: { config: LOGIN_CONFIGS['partner'] },
    loadComponent: () =>
      import('./components/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'loginAgents',
    data: { config: LOGIN_CONFIGS['agent'] },
    loadComponent: () =>
      import('./components/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'logout',
    loadComponent: () =>
      import('./components/logout-page/logout-page.component').then(
        (m) => m.LogoutPageComponent,
      ),
  },
];
